import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
export function getOptionsCountry() {
    const countries = require("@/data/countries.json");
    let optionsCountry = {};

    countries.forEach(function (country) {
        //optionsCountry[country['code_iso2'] + '_' + country['name_fr']] = country['name_fr'];
        optionsCountry[country['code_iso2']] = country['name_fr'];
    });

    return optionsCountry;
}

export function getCountryNameByCode(codeCountry) {
    const countries = require("@/data/countries.json");

    for (let i= 0; i < countries.length; i++) {
        if (codeCountry === countries[i]['code_iso2']) {
            return countries[i]['name_fr'];
        }
    }

    return null;
}

export function getCountryCodeByName(countryName) {
    const countries = require("@/data/countries.json");

    for (let i= 0; i < countries.length; i++) {
        if (countryName === countries[i]['name_fr']) {
            return countries[i]['code_iso2'];
        }
    }

    return countryName; // Return the original value if no match is found
}

export async function deleteGeolocation(uuid: string) {
    try {
        await ApiService.delete(`customer/geolocation-products/${uuid}`);
    } catch (error) {
        swal.error("Une erreur est survenue lors de la suppression de la géolocalisation.");
    }
}
